import {
  type DisclaimerLayerAppearance,
  DisclaimerLayer as DisclaimerLayerComponent,
  withFocusLock,
} from '@volkswagen-onehub/components-core';
import {
  DisclaimerLayerAppearanceV2,
  type DisclaimerLayerOptionsV2,
  type LayerV2,
} from '@volkswagen-onehub/layer-manager';
import * as React from 'react';

import {LayerContent} from './layer-content';

export interface DisclaimerLayerProps {
  readonly layer: LayerV2<unknown, DisclaimerLayerOptionsV2>;
  scrollElementRef(el: HTMLDivElement): void;
}

const layerAppearance: {
  [key in DisclaimerLayerAppearanceV2]: DisclaimerLayerAppearance;
} = {
  [DisclaimerLayerAppearanceV2.DARK]: 'dark',
  [DisclaimerLayerAppearanceV2.LIGHT]: 'light',
};

const Layer: React.FunctionComponent<DisclaimerLayerProps> = (props) => {
  const {layer, scrollElementRef, ...ownProps} = props;
  const {options} = layer;

  return (
    <DisclaimerLayerComponent
      {
        ...ownProps /* Used to pass through the animation props */
      }
      appearance={options.appearance && layerAppearance[options.appearance]}
      scrollElementRef={scrollElementRef}
      aria-labelledby={options['aria-labelledby']}
    >
      <LayerContent layer={layer} />
    </DisclaimerLayerComponent>
  );
};

export const DisclaimerLayer: React.ElementType =
  withFocusLock<DisclaimerLayerProps>(Layer);
